import * as numeral from 'numeral';
import * as moment from 'moment';
import translate from './translate';

const catalogs = {
    de: require('../locale/de.json'),
    en: require('../locale/en.json')
};

const libs = {
    de: [
        require('numeral/locales/de'),
        require('moment/locale/de'),
    ],
    en: [
        require('numeral/locales/en-gb'),
        require('moment/locale/en-gb'),
    ]
};

export default function configureLocale(lang = 'de') {
    numeral.locale(lang);
    moment.locale(lang);

    translate.addCatalog(lang, catalogs[lang]);
    translate.locale(lang);
}


// WEBPACK FOOTER //
// ./src/locale/configureLocale.ts